import {
    Button,
    Tab,
    Tabs,
    Overlay,
    NavBar,
    Icon,
    Swipe,
    SwipeItem,
    Divider,
    Cell,
    CellGroup,
    Empty,
    Toast,
    Loading,
    List,
    Popup,
    CountDown
} from 'vant';

const registerVenderComponents = Vue => {
    Vue.use(Button);
    Vue.use(Loading);
    Vue.use(Tab);
    Vue.use(Tabs);
    Vue.use(Overlay);
    Vue.use(NavBar);
    Vue.use(Icon);
    Vue.use(Swipe);
    Vue.use(SwipeItem);
    Vue.use(Divider);
    Vue.use(Cell);
    Vue.use(CellGroup);
    Vue.use(Empty);
    Vue.use(Toast);
    Vue.use(List);
    Vue.use(Popup);
    Vue.use(CountDown);
};

const customComponents = [];

const registerCustomComponents = (Vue, components) => {
    components.map(component => {
        Vue.component(component.tag, component.vue);
    });
};

export const registerComponents = Vue => {
    registerCustomComponents(Vue, customComponents);
    registerVenderComponents(Vue);
};
